// Upload filters for the estimating module.

export function visibleForAI(files) {
  // AI analyse/estimate can only read PDFs and images.
  return (files || []).filter((f) => {
    const ct = (f?.content_type || "").toLowerCase();
    return ct.includes("pdf") || ct.startsWith("image/");
  });
}
